import {
	Box,
	Button,
	Card,
	CardHeader,
	CardContent,
	Collapse,
	IconButton,
	InputAdornment,
	Divider,
	makeStyles,
	TextField,
	Typography
} from '@material-ui/core'
import { ExpandMoreOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useState } from 'react'


const useStyles = makeStyles((theme) => ({
	yeah: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '1fr 1fr 1fr',
		marginBottom: '50px'
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				width: '100%'
			}
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': { width: '40%', minWidth: '40%' },
		marginBottom: 36,
		width: '100%'
	},
	checkBox: {
		display: 'flex',
		flexDirection: 'row'
	},
	input: {
		display: 'none'
	},
	title: {
		fontSize: 16,
		fontWeight: '800',
		color: '#1a1a35'
	},
	subTitle: {
		fontSize: 14,
		fontWeight: '600',
		color: '#1a1a35',
		// marginTop: 6,
		marginBottom: 8
	},
	subTitle2: {
		fontSize: 14,
		fontWeight: '600',
		color: '#1a1a35',
		// marginTop: 6,
		marginBottom: 16
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	dayRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 24,
		paddingLeft: 36,
		paddingRight: 36,
		borderRadius: 8,
		marginBottom: 16,
		boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)'
	},
	dayColumn: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		padding: 24,
		paddingBottom: 0,
		paddingLeft: 36,
		paddingRight: 36,
		borderRadius: 8,
		// marginBottom: 16,
		// boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)'
	},
	times: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		paddingTop: 24,
		// paddingLeft: 36,
		// paddingRight: 36,
		// borderRadius: 8,
		marginBottom: 16,
		// boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)'
	},
	intRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	clearBtn: {
		fontSize: 12,
		fontWeight: '800',
		marginLeft: 36,
		color: '#6B4AD6',
		textAlign: 'left'
	},
	overflow: {
		marginBottom: 24
	},
	overflowInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start'
	},
	overflowBox: {
		paddingTop: 12,
		marginRight: 24
	}
}))

const CapacityControl = (props) => {
	const classes = useStyles()
	const [general, setGeneral] = useState(true)
	const [daycare, setDaycare] = useState(false)
	const [compat, setCompat] = useState(false)
	const [overflow, setOverflow] = useState(false)

	let { selectedFacility, setCurrent } = props

	const days = [
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
		'Sunday'
	]

	const getOverFlows = () => {
		let facility = selectedFacility
		// console.log('fac....', facility)
		if (!facility || !facility?.capacity?.overflow) return []

		let flows = []

		for (let o in facility?.capacity?.overflow) {
			flows.push({ ...facility?.capacity?.overflow[o], name: o })
		}

		return flows
	}

	const overflows = getOverFlows()

	const updateOverflows = (val, period, type) => {

		const newFacility = {
			...selectedFacility,
			capacity: {
				...selectedFacility.capacity,
				overflow: {
					...selectedFacility.capacity.overflow,
					[period]: {
						...selectedFacility.capacity.overflow[period],
						[type]: Number(val)
					}
				}
			}
		}

		// setCurrent(newFacility)

		let { period_one, period_two, period_three } = newFacility.capacity.overflow
		let new_period_one = { ...period_one }
		let new_period_two = { ...period_two }
		let new_period_three = { ...period_three }

		// first period
		if (new_period_one.end_days <= new_period_one.start_days) {
			new_period_one.end_days = new_period_one.start_days + 1
		}

		if (new_period_one.overflow_dogs > new_period_two.overflow_dogs) new_period_two.overflow_dogs = new_period_one.overflow_dogs

		// second period
		new_period_two.start_days = new_period_one.end_days + 1


		if (new_period_two.end_days <= new_period_two.start_days) {
			new_period_two.end_days = new_period_two.start_days + 1
		}

		if (new_period_two.overflow_dogs > new_period_three.overflow_dogs) new_period_three.overflow_dogs = new_period_two.overflow_dogs

		// third period
		new_period_three.start_days = new_period_two.end_days + 1

		if (new_period_three.end_days <= new_period_three.start_days) {
			new_period_three.end_days = new_period_three.start_days + 1
		}

		newFacility.capacity.overflow.period_one = new_period_one
		newFacility.capacity.overflow.period_two = new_period_two
		newFacility.capacity.overflow.period_three = new_period_three


		setCurrent(newFacility)

	}

	const isAllowedNumber = (val) => {
		if (val > 0 && val < 19) return true
	}

	return (
		<React.Fragment>
			<Card style={{ maxWidth: '1145px' }}>
				<CardHeader
					title="GENERAL CAPACITY SETTINGS"
					action={
						<IconButton
							size="medium"
							className={clsx(classes.expand, {
								[classes.expandOpen]: general
							})}
							onClick={() => setGeneral(!general)}
							aria-expanded={general}
							aria-label="show more">
							<ExpandMoreOutlined style={{ fill: '#777679' }} fontSize="large" />
						</IconButton>
					}
				/>
				<Collapse in={general}>
					<CardContent style={{ padding: 24, paddingTop: 0 }}>
						<div className={classes.yeah}>
							<Typography variant="body1" className={classes.subTitle2} style={{ marginBottom: 24 }}>
								This section will be used to set the universal capacity settings for pet care at this facility. This capacity settings should NOT be changed unless the facility is permenantly gaining or losing capacity in one of the following sections.
							</Typography>

							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<Typography variant="body1" className={classes.title}>
									Total Capacity
								</Typography>
								<Typography variant="body1" className={classes.subTitle} style={{ marginTop: 12, marginBottom: 16 }}>
									Set the total capacity for any given day.
								</Typography>
								<TextField
									label="Total Capacity"
									variant="filled"
									type="number"
									value={selectedFacility.capacity.total}
									disabled={!selectedFacility.active}
									onChange={(e) =>
										setCurrent({
											...selectedFacility,
											capacity: {
												...selectedFacility.capacity,
												total: e.target.value
											}
										})
									}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<Typography variant="body1" className={classes.title}>
									Daytime Capacity
								</Typography>
								<Typography variant="body1" className={classes.subTitle} style={{ marginTop: 12, marginBottom: 16 }}>
									Set the total capacity for daytime sessions (daycare-only & boarding with daycare) per day.</Typography>
								<TextField
									label="Daytime Capacity"
									variant="filled"
									value={selectedFacility.capacity.daytime}
									type="number"
									disabled={!selectedFacility.active}
									onChange={(e) => {
										if (Number(e.target.value) <= Number(selectedFacility.capacity.total) && Number(e.target.value >= 0)) {
											setCurrent({
												...selectedFacility,
												capacity: {
													...selectedFacility.capacity,
													daytime: e.target.value
												}
											})
										}
									}
									}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<Typography variant="body1" className={classes.title}>
									Overnight Capacity
								</Typography>
								<Typography variant="body1" className={classes.subTitle} style={{ marginTop: 12, marginBottom: 16 }}>
									Set the total capacity for overnight kennels per night.
								</Typography>
								<TextField
									label="Overnight Capacity"
									variant="filled"
									value={selectedFacility.capacity.overnight}
									disabled={!selectedFacility.active}
									type="number"
									onChange={(e) => {
										if (Number(e.target.value) <= Number(selectedFacility.capacity.total) && Number(e.target.value >= 0)) {
											setCurrent({
												...selectedFacility,
												capacity: {
													...selectedFacility.capacity,
													overnight: e.target.value
												}
											})
										}
									}
									}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<Typography variant="body1" className={classes.title}>
									Welcome Day Capacity
								</Typography>
								<Typography variant="body1" className={classes.subTitle} style={{ marginTop: 12, marginBottom: 16 }}>
									The maximum number of Welcome Day dogs for any given day.
								</Typography>
								<TextField
									label="Welcome Day Capacity"
									variant="filled"
									value={selectedFacility.capacity.welcome_day}
									disabled={!selectedFacility.active}
									type="number"
									onChange={(e) => {
										if (Number(e.target.value) <= Number(selectedFacility.capacity.total) && Number(e.target.value >= 0)) {
											setCurrent({
												...selectedFacility,
												capacity: {
													...selectedFacility.capacity,
													welcome_day: e.target.value
												}
											})
										}
									}
									}
								/>
							</div>




						</div>
					</CardContent>
				</Collapse>
			</Card>

			<Card style={{ maxWidth: '1145px' }}>
				<CardHeader
					title="DAILY DAYCARE CAPACITY SETTINGS"
					action={
						<IconButton
							size="medium"
							className={clsx(classes.expand, {
								[classes.expandOpen]: daycare
							})}
							onClick={() => setDaycare(!daycare)}
							aria-expanded={daycare}
							aria-label="show more">
							<ExpandMoreOutlined style={{ fill: '#777679' }} fontSize="large" />
						</IconButton>
					}
				/>
				<Collapse in={daycare}>
					<CardContent style={{ padding: 24, paddingTop: 0 }}>
						<div className={classes.yeah}>
							<div className={classes.fieldWrapper2}>
								<Typography variant="body1" className={classes.subTitle2}>
									This section will solely be used to control the amount of daycare appoinments that can be booked by day of the week - at this specific facility. Each of the daily daycare capacity fields will live within the overaching daytime capacity field, and will be used to set how many of the daytime capacity slots can be filled with daycare dogs on a given day.
								</Typography>
								<Typography variant="body1" className={classes.subTitle2} style={{ marginBottom: 16 }}>
									<strong>Instructions:</strong> Enter a daycare capacity limit lower than the daytime capacity limit. Click ‘Clear Setting’ to remove the current cap.
								</Typography>
								{days.map(d => {
									return (
										<div className={classes.dayRow}>
											<Typography variant="body1" className={classes.title}>{d}</Typography>
											<div className={classes.intRow}>
												<TextField
													label={`${d} Daycare Capacity`}
													variant="filled"
													value={selectedFacility.capacity.daycare_days[d]}
													disabled={!selectedFacility.active}
													type="number"
													onChange={(e) => {
														if (Number(e.target.value) <= Number(selectedFacility.capacity.daytime) && Number(e.target.value >= 0)) setCurrent({
															...selectedFacility,
															capacity: {
																...selectedFacility.capacity,
																daycare_days: {
																	...selectedFacility.capacity.daycare_days,
																	[d]: e.target.value
																}
															}
														})
													}
													}
												/>
												<Button variant="text" className={classes.clearBtn} onClick={() => {
													setCurrent({
														...selectedFacility,
														capacity: {
															...selectedFacility.capacity,
															daycare_days: {
																...selectedFacility.capacity.daycare_days,
																[d]: ''
															}
														}
													})
												}}>Clear<br /> Setting</Button>
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</CardContent>
				</Collapse>
			</Card>
			<Card style={{ maxWidth: '1145px' }}>
				<CardHeader
					title="OVERFLOW CAPACITY SETTINGS"
					action={
						<IconButton
							size="medium"
							className={clsx(classes.expand, {
								[classes.expandOpen]: overflow
							})}
							onClick={() => setOverflow(!overflow)}
							aria-expanded={overflow}
							aria-label="show more">
							<ExpandMoreOutlined style={{ fill: '#777679' }} fontSize="large" />
						</IconButton>
					}
				/>
				<Collapse in={overflow}>
					<CardContent style={{ padding: 24, paddingTop: 0 }}>
						<div className={classes.yeah}>
							<div className={classes.fieldWrapper2}>
								<Typography variant="body1" className={classes.subTitle2}>
									This section is used to control the settings for the overflow dogs allowed in pet care each day. A dog can only be added to the overflow list for a day, if they are booked on a boarding appointment that has one or more full daytime sessions within the appointment. This section lets the user define the overflow periods, and how many overflow dogs are allowed when a full daycare day is within any of these periods.
									<br />
									<br />
									An appointment day is within an “Overflow Period” if it falls between one of the period’s ranges from the day when booked it is booked by the client.
								</Typography>
							</div>
							{overflows.map((period, i) => {
								return (
									<div className={classes.overflow}>
										<Typography variant='h6' style={{ fontSize: 16 }}>Overflow Period {i + 1}</Typography>
										<div className={classes.overflowInt}>
											<div className={classes.overflowBox}>
												<Typography variant="h6" style={{ fontSize: 12, fontWeight: '800', marginBottom: 6 }}>Start of Period</Typography>
												<TextField
													label={`Start of Period`}
													variant="filled"
													value={period.start_days}
													disabled={!selectedFacility.active || (period.name === 'period_two' || period.name === 'period_three')}
													style={{ maxWidth: 250, width: 250, minWidth: 250 }}
													type="number"
													onChange={(e) => {
														if (isAllowedNumber(e.target.value)) updateOverflows(e.target.value, period.name, 'start_days')
													}
													}
													InputProps={{
														endAdornment: <InputAdornment position="end">Days</InputAdornment>,
													}}
												/>
											</div>
											<div className={classes.overflowBox}>
												<Typography variant="h6" style={{ fontSize: 12, fontWeight: '800', marginBottom: 6 }}>End of Period</Typography>
												<TextField
													label={`End of Period`}
													variant="filled"
													value={period.name === 'period_three' ? 'None' : period.end_days}
													disabled={!selectedFacility.active || (period.name === 'period_three')}
													style={{ maxWidth: 250, width: 250, minWidth: 250 }}
													type={period.name === 'period_three' ? 'text' : 'number'}
													onChange={(e) => {
														updateOverflows(e.target.value, period.name, 'end_days')
													}
													}
													InputProps={{
														endAdornment: <InputAdornment position="end">Days</InputAdornment>,
													}}
												/>
											</div>
										</div>
										<div className={classes.overflowInt}>
											<div className={classes.overflowBox}>
												<Typography variant="h6" style={{ fontSize: 12, fontWeight: '800', marginBottom: 6 }}>Overflow Dogs Allowed</Typography>
												<TextField
													label={`Overflow Dogs Allowed`}
													variant="filled"
													value={period.overflow_dogs}
													disabled={!selectedFacility.active}
													style={{ maxWidth: 250, width: 250, minWidth: 250 }}
													type="number"
													onChange={(e) => {
														if (e.target.value > -1 && e.target.value < 100) {
															let min
															if (period.name === 'period_one') min = 0
															if (period.name === 'period_two') min = selectedFacility.capacity.overflow.period_one.overflow_dogs
															if (period.name === 'period_three') min = selectedFacility.capacity.overflow.period_two.overflow_dogs
															if (e.target.value >= min) updateOverflows(e.target.value, period.name, 'overflow_dogs')
														}
													}
													}
													InputProps={{
														endAdornment: <InputAdornment position="end">Dogs</InputAdornment>,
													}}
												/>
											</div>
										</div>
									</div>
								)
							})}
						</div>
					</CardContent>
				</Collapse>
			</Card>
		</React.Fragment>
	)
}

export default CapacityControl
